export function SRLink({ href, text }) {
  return (
    <a className="sr-only" href={href} tabIndex={-1}>
      {text}
    </a>
  );
}
